export default "__VITE_ASSET__VfYozlPX__"